import { useLingui } from "@lingui/react/macro";
import { regionApi } from "@/lib/api/services/region.api";
import type { Region } from "@/types/region";
import { EntitySelect } from "./EntitySelect";

export interface RegionSelectProps {
  value: number | null | undefined;
  onChange: (value: number, region: Region) => void;
  onClear?: () => void;
  companyId?: number;
  isActive?: boolean;
  displayValue?: string;
  placeholder?: string;
  disabled?: boolean;
  triggerClassName?: string;
}

export function RegionSelect({
  value,
  onChange,
  onClear,
  companyId,
  isActive,
  displayValue,
  placeholder,
  disabled,
  triggerClassName,
}: RegionSelectProps) {
  const { t } = useLingui();
  return (
    <EntitySelect<Region>
      queryKeyBase={["entity-select", "regions", companyId ?? null, isActive ?? null]}
      fetchPage={({ page, limit, search }) =>
        regionApi.paginate({ page, limit, search: search || undefined, companyId, isActive })
      }
      getOptionValue={(r) => String(r.id)}
      getOptionLabel={(r) => r.name}
      fetchItem={(id) => regionApi.getById(Number(id))}
      value={value == null ? "" : String(value)}
      onChange={(val, region) => onChange(Number(val), region)}
      onClear={onClear}
      displayValue={displayValue}
      placeholder={placeholder ?? t`Select a region...`}
      searchPlaceholder={t`Search regions…`}
      emptyMessage={t`No regions found`}
      disabled={disabled}
      triggerClassName={triggerClassName}
    />
  );
}
